import React from 'react';
import { Paper, Box, Grid, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import CellValue from './cell-value.component';

const ViewGridData = ({ columns, row }) => (
  <Box component={Paper} padding={2}>
    <Grid container spacing={2}>
      {columns.map((c) =>
        c.sectionHeader ? (
          <>
            <Grid item xs={12} sm={12} md={12}>
              <Divider
                textAlign="center"
                variant="fullWidth"
                sx={{ fontWeight: 'bold', mt: 2 }}
              >
                {c.label}
              </Divider>
            </Grid>
            {c.sectionHeaderNote && (
              <Grid item xs={12} sm={12} md={12}>
                <Box color="red" fontSize="small">
                  {c.sectionHeaderNote}
                </Box>
              </Grid>
            )}
          </>
        ) : (
          <Grid
            item
            xs={12}
            sm={c.showFullGrid ? 12 : 6}
            md={c.showFullGrid ? 12 : 6}
          >
            <Box fontWeight="bold">{c.label}</Box>
            <CellValue
              type={c.type}
              dataKey={c.dataKey}
              value={
                row[c.dataKey] !== null && row[c.dataKey] !== ''
                  ? row[c.dataKey]
                  : '-'
              }
            />
          </Grid>
        )
      )}
    </Grid>
  </Box>
);

ViewGridData.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  row: PropTypes.shape().isRequired,
};

export default ViewGridData;
